export default __webpack_public_path__ + "static/media/toggle-on.02092e12.svg";